var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntCatalogueMenuIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 25,
    height: 22,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31415 14.013V20.7569C6.31415 21.5453 6.95317 22.1843 7.74156 22.1843H17.2572C18.0456 22.1843 18.6846 21.5453 18.6846 20.7569V14.013C19.5242 14.8738 20.8598 15.057 21.7856 14.1928L23.6949 12.4101C24.3729 11.7772 24.576 10.7656 24.1541 9.91571C23.1982 7.99009 22.239 6.45156 20.8958 5.32921C19.5313 4.18897 17.8578 3.54852 15.6022 3.23888C14.7284 3.1188 13.9032 3.56666 13.4902 4.30026L12.4994 6.05984L11.5087 4.30026C11.0957 3.56662 10.2705 3.11877 9.39667 3.23888C7.14087 3.54853 5.46734 4.18897 4.10305 5.32921C2.75986 6.45156 1.80085 7.99004 0.844795 9.91571C0.422829 10.7656 0.625943 11.7772 1.304 12.4101L3.2133 14.1928C4.13908 15.057 5.47459 14.8738 6.31415 14.013Z",
    fill: "#5D5FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.12439L12.5 23.309",
    stroke: "#F2F1FE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntCatalogueMenuIconFilled);
export default __webpack_public_path__ + "static/media/EntCatalogueMenuIconFilled.08170485c692b030f930ce29d957c031.svg";
export { ForwardRef as ReactComponent };